import { useMemo } from "react";

import { useDynamicListingFeePackages } from "@/Apollo/hooks/pay-per-listing/useDynamicListingFeePackages";
import { ProductUnknown } from "@/common/contracts/product.contracts";
import { useLanguage } from "@/common/hooks/pages.hooks";
import { ListingFeePackage } from "@/features/create-ad-packages/contracts/create-ad-packages.contracts";
import { toListingFeePackages } from "@/features/create-ad-packages/utils/listingFeePackages.utils";

const NO_PACKAGES: ListingFeePackage[] = [];

/**
 * Loads the dynamic pay-per-listing packages for a product and maps them into
 * the view model the success-page cards render (see `toListingFeePackages`).
 */
export const useCreateAdListingFeePackages = (product?: ProductUnknown) => {
  const { language } = useLanguage();

  const { data, loading, error } = useDynamicListingFeePackages({
    variables: { productId: product?.id, lang: language },
    skip: !product?.id,
  });

  const packages = useMemo<ListingFeePackage[]>(() => {
    const options = data?.dynamicListingFeePackages;

    if (!options?.length) {
      return NO_PACKAGES;
    }

    return toListingFeePackages(options);
  }, [data?.dynamicListingFeePackages]);

  return { packages, loading, error };
};
